/* eslint no-extra-parens: "off", complexity: "off" */
import React from 'react'
import styled from 'styled-components'

import fillNullCashflowData from './helpers/fillNullCashflowData'

const Container = styled.div`
  display: flex;
  flex-direction: column; 
  border: 2px solid #eeeeee;
`
const Header = styled.h3`
  margin-top: 20px;
`
const MarginHeader = styled.div`
  display: grid;
  grid-template-columns: 3fr repeat(5, 1fr);
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(5,1fr);
  &:nth-of-type(odd) {
    background: #EEEEEE;
  }
`
const Year = styled.div`
  text-align: right;
  font-weight: bold;
  padding: 8px;
`
const Segment = styled.div`
  display: grid;
  grid-template-columns: 1fr 7fr;
  border-top: 9px solid #f8f8f8;
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const Title = styled.div`
  font-weight: bold;
  background: #dfdfdf;
  padding: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
`
const Cell = styled.div`
  text-align: right;
  padding: 8px;
`
const RowTitle = styled.div`
  padding: 8px;
`

export default class MarginAnalysis extends React.Component {
  renderHeader = () => {
    const { years } = this.props
    return Array.from(years.keys()).map(year => {
      return <Year key={`margin-${year}`}>{year}</Year>
    })
  }
  renderGrowthByCategory = (category, segment) => {
    const { cashflowData, years, fiscalYears } = this.props
    const data = cashflowData.filter(datum => datum.category === category.key)
    const filledLatestData = fillNullCashflowData(data, years, category.key)
    const cogsData = fillNullCashflowData(cashflowData.filter(d => d.category === 'cogs'), years, 'cogs')
    const margins = []
    for (let i = 0; i < filledLatestData.length; i++) {
      const datum = filledLatestData[i]
      const annualizationCoefficient = fiscalYears.find(fy => fy.year === datum.year).annualizationCoefficient
      if (i > 0 && segment.key === 'growth') {
        const previousDatum = filledLatestData[i - 1]
        if (datum.data && previousDatum.data) {
          let margin
          if (years.get(datum.year).period === 'interim' && category.key !== 'net_profit' && category.key !== 'cash_available_for_debt_service') {
            margin = ((((datum.data * annualizationCoefficient) - previousDatum.data) / previousDatum.data) * 100)
          } else {
            margin = (((datum.data - previousDatum.data) / previousDatum.data) * 100)
          }
          margins.push(`${margin.toFixed(1)}%`)
        } else {
          margins.push('N/A')
        }
      } else if (segment.key === 'margin') {
        const grossRevenueData = cashflowData.filter(d => d.category === 'gross_revenue')
        const grossRevenueForYear = grossRevenueData.filter(d => d.year === datum.year).sort((a, b) => b.createdAt - a.createdAt)
        const grossRevenue = grossRevenueForYear[0]
        const cogs = cogsData.find(d => d.year === datum.year)
        if (category.key === 'gross_revenue' && grossRevenue && datum.data && grossRevenue.data) {
          let margin
          if (years.get(datum.year).period === 'interim') {
            margin = (((grossRevenue.data * annualizationCoefficient) - ((cogs.data ? cogs.data : 0) * annualizationCoefficient)) / (grossRevenue.data * annualizationCoefficient)) * 100
          } else {
            margin = ((grossRevenue.data - (cogs.data ? cogs.data : 0)) / grossRevenue.data) * 100
          }
          margins.push(`${margin.toFixed(1)}%`)
        } else if (grossRevenue && datum.data && grossRevenue.data) {
          let margin
          if (years.get(datum.year).period === 'interim' && category.key !== 'cash_available_for_debt_service' && category.key !== 'net_profit') {
            margin = ((datum.data * annualizationCoefficient) / (grossRevenue.data * annualizationCoefficient)) * 100
          } else if (years.get(datum.year).period === 'interim' && (category.key === 'cash_available_for_debt_service' || category.key === 'net_profit')) {
            margin = (datum.data / (grossRevenue.data * annualizationCoefficient)) * 100
          } else {
            margin = (datum.data / grossRevenue.data) * 100
          }
          margins.push(`${margin.toFixed(1)}%`)
        } else {
          margins.push('N/A')
        }
      } else {
        margins.push('N/A')
      }
    }
    return margins.map((margin, i) => {
      return <Cell key={`margin-${category.key}-${i}`}>{margin}</Cell>
    })
  }
  renderSegments = () => {
    const { segments } = this.props
    return segments.map(segment => {
      return (
        <Segment key={`margin-${segment.title}`}>
          <Title>{segment.title}</Title>
          <RowContainer>
            {
              segment.categories.map(category => {
                return (
                  <Row key={category.title}>
                    <RowTitle>{category.title}</RowTitle>
                    {this.renderGrowthByCategory(category, segment)}
                  </Row>
                )
              })
            }
          </RowContainer>
        </Segment>
      )
    })
  }
  render() {
    const { name } = this.props
    return (
      <section>
        <Header>Margin Analysis for {name}</Header>
        <Container>
          <MarginHeader>
            <div />
            {this.renderHeader()}
          </MarginHeader>
          {this.renderSegments()}
        </Container>
      </section>
    )
  }
}